import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import L from "leaflet";
import "leaflet.markercluster/dist/leaflet.markercluster.js";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import ReactDOMServer from "react-dom/server";
import Location from "../../../../src/components/images/location_red.svg";
import BlueLocation from "../../../../src/components/images/Tower_Icon_Blue.svg";
import { useTranslation } from "react-i18next";
import { MDBBtn, MDBIcon, MDBSpinner, MDBTable, MDBTableBody, MDBTableHead, MDBPopconfirm, MDBPopconfirmMessage, MDBCheckbox, MDBModalFooter, MDBChip, MDBInput, MDBTabs, MDBTabsItem, MDBTabsLink, MDBTabsContent, MDBTabsPane } from "mdb-react-ui-kit";
import { getAllTheLocationsInfo } from "../../../apiclients/streamsapi_bridge";
import ReactDOM from "react-dom";
import { TowerIconBlue, TowerIconRed } from "../../../components/images/index"
import AddLocations from "./AddLocations";
import PopupLoaderNew from "../PopupLoaderNew";
import Select from "react-select"; // Import react-select for dropdown
import AddNineOneOneLocation from "./Add911Location";
import TabIDConstant from "../../../apiclients/TabIDConstant";
import UIConstant from "../../../apiclients/UIConstant";


function LocationMap(props) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);
  const [locationNames, setlocationNames] = useState(null);
  const [fillData, setFillData] = useState(null);
  const map = useRef(null);
  const searchRef = useRef(null);
  const devices_rows = useRef(null);
  console.log("Map Component request reached:");
  let [isloading, setIsloading] = useState(true);
  let [isloadingMap, setIsloadingMap] = useState(false);

  const navigate = useNavigate();
  const tableHeaders = ["Primary Contact", "911 Verified", ""];
  const tableHeadersNew = ["Name", "911 Verified", "Primary Contact", ""];
  const [showAddLocationPopup, setShowAddLocationPopup] = useState(false);
  const toggleAddLocationPopup = (event) => {
    // event.stopPropagation();  // Prevent event bubbling
    setShowAddLocationPopup(prev => !prev); // Toggle state properly
  };

  const addLocationRef = useRef(null);

  function handleClick() {
    addLocationRef.current.click();
  }
  const [searchTerm, setSearchTerm] = useState("");
  const [locations, setLocations] = useState([]);
  const [filteredLocations, setFilteredLocations] = useState(locationNames);
  const [filterSelectedLocations, setFilterSelectedLocations] = useState([]);
  const [showLocation, setShowLocation] = useState(false);
  const [selectedLocationchips, setSelectedLocationchips] = useState("");
  const [tempSelectedLocations, setTempSelectedLocations] = useState([]);
  const [tempSelectedLocations2, setTempSelectedLocations2] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [allLocation, setAllLocation] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchData, setSearchData] = useState([]);


  useEffect(() => {
    if (locationNames && locationNames.length > 0) {
      const locationOptions = locationNames.map(loc => ({ label: loc, value: loc }));
      setSearchData(locationOptions);
    }
  }, [locationNames]);


  const handleChange = (selectedOption) => {
    if (selectedOption?.value === "All Locations" || !selectedOption) {
      // If "All Locations" is selected, reset the map to show all locations
      setFilterSelectedLocations([]); // Clear any selected filters
      setTempSelectedLocations([]); // Clear temporary selections
      setData(fillData); // Reset the map data to show all locations
      setSelectedLocation(null);
      setSelectedOption(selectedOption);
      handleBasicClick(basicActive,2)
    } else {
      // Handle other selections
      let fillLocations = fillData.filter((location) => selectedOption?.value.includes(location?.geometry?.location_name));
      console.log("Selected Option:", selectedOption);
      setSelectedOption(selectedOption);
      setData(fillLocations);
    }
  };

  useEffect(() => {
    if (!showAddLocationPopup) {
      setShowAddLocationPopup(false);
    }
  }, [showAddLocationPopup]);

  const inputSearchRef = useRef(null);

  const toggleLocation = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setShowLocation(prev => !prev); // Ensure it toggles properly
    setTempSelectedLocations(filterSelectedLocations);   // Reset selected locations when opening filter
    setTimeout(() => {
      inputSearchRef.current.focus()
    },500)
  };
  const handleFilterLocations = (location) => {
    console.log("handlefilterlocations ::", tempSelectedLocations);
    let updatedSelections;
    if (tempSelectedLocations.includes(location)) {
      updatedSelections = tempSelectedLocations.filter(item => item !== location);
    } else {
      updatedSelections = [...tempSelectedLocations, location];
    }
    setTempSelectedLocations(updatedSelections)
    const filteredLocationNames = locationNames.filter((loc) => loc.toLowerCase() !== "all locations" && loc.toLowerCase().includes(searchValue.toLowerCase()));
    const allSelected = filteredLocationNames.every(loc => updatedSelections.includes(loc))
    setAllLocation(allSelected)
  };
  const handleFilterLocations2 = (location) => {
    console.log("handleFilterLocations2 ::", tempSelectedLocations)
    setData(fillData)

    if (tempSelectedLocations.includes(location) || tempSelectedLocations2.includes(location)) {
      setTempSelectedLocations(tempSelectedLocations.filter(item => item !== location));
      setTempSelectedLocations2(tempSelectedLocations2.filter(item => item !== location));
    } else {
      setTempSelectedLocations([...tempSelectedLocations, location]);
      setTempSelectedLocations2([...tempSelectedLocations2, location]);
    }
  };

  const clearFilterData = () => {
    setFilterSelectedLocations([]);
    setSelectedLocationchips("");
    setTempSelectedLocations([]);
    setSearchData(locationNames.map(loc => ({ label: loc, value: loc })));
    setSearchValue("");
    // setData(fillData);
    // handleBasicClick('tab1')
    handleBasicClick(basicActive, 2)
    setAllLocation(false)
  };

  useEffect(() => {
    if (showLocation) {
      setTempSelectedLocations([]);
    }
  }, [showLocation]);

  const toggleBackClick = (e, step) => {
    e.stopPropagation();
    console.log("Going back from step:", step);
    setShowLocation(false);  // Hide location filter UI
  };

  const cancelFilter = (step) => {
    console.log("Cancel filter at step:", step);
    setFilterSelectedLocations([]); // Clear selected locations
    setShowLocation(false); // Hide filter UI
    setTempSelectedLocations(filterSelectedLocations); // Revert temp to original
    setSearchValue("");


  };

  const cancelFill = () => {
    console.log(tempSelectedLocations2)
    let locations = tempSelectedLocations.filter((loc) => !tempSelectedLocations2.includes(loc))
    setTempSelectedLocations(locations)
    setTempSelectedLocations(filterSelectedLocations); // Revert to original selected locations
    setShowLocation(false)
  }

  const filterLocations = (e) => {
    e.preventDefault();
    let fillLocations = fillData.filter((location) => tempSelectedLocations.includes(location.geometry.location_name));
    console.log("fillloactins", fillLocations)
    console.log("tempseletedloctions", tempSelectedLocations)
    console.log("filldata", fillData)
    setData(fillLocations);
    setSearchValue("");
    setSelectedOption("");
    // If "All Locations" is selected, set the filterSelectedLocations to only "All Locations"
    if (allLocation) {
      setFilterSelectedLocations(["All Locations"]);
    } else {
      setFilterSelectedLocations([...tempSelectedLocations]); // Save selected locations
    }

    setShowLocation(false); // Close the filter UI


    if (map.current) {
      // Clear all markers/layers from the map
      map.current.eachLayer((layer) => {
        if (layer instanceof L.Marker || layer instanceof L.LayerGroup) {
          map.current.removeLayer(layer);
        }
      });

      // Reload the map with the filtered locations
      loadMap();
    }
  };


  useEffect(() => {
    const fetchLocations = async () => {
      // Assuming AllLocation provides a list of locations
      const uniqueLocations = [];
      setLocations(uniqueLocations);
      setFilteredLocations(uniqueLocations);

    };
    fetchLocations();
  }, []);

  useEffect(() => {
    const filtered = locations.filter((loc) =>
      loc.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredLocations(filtered);
  }, [searchTerm, locations]);

  const [data1, setData1] = useState();
  const handleMapLocationSearch = (inputValue) => {
    let fillLocations = fillData.filter((location) => tempSelectedLocations.includes(location.geometry.location_name));
    console.log("Searching for:", inputValue);
    if (inputValue) {
      setData1(inputValue);
      setSelectedOption([{ label: inputValue, value: inputValue }]);
      setData(fillLocations)
      setData(data)
    }
  };



  const closeSearch = (e) => {
    console.log("Menu closed" + data);
    setData1(data);
    setData(fillData)
  }
  const closePopup = () => {
    setShowAddLocationPopup(false);
  };
  const handleAllLocation = (e) => {
    const checked = e.target.checked;
    setAllLocation(checked);

    if (checked) {
      // Select only filtered locations
      setTempSelectedLocations(
        locationNames.filter((location) =>
          location.toLowerCase() !== "all locations" &&
          location.toLowerCase().includes(searchValue.toLowerCase())
        )
      );
    } else {
      // Deselect all locations
      setTempSelectedLocations([]);
    }
  };
  async function getLocationsInfo() {
    try {
      console.log("getLocationsInfo  node server request :");
      let apirespone = await getAllTheLocationsInfo(
        JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        TabIDConstant.LOC_MAP_SUBLINK
      );
      console.dir(apirespone);
      if (!apirespone.ok) {
        console.log(
          "Network response was not ok ! there might be some issue exist at api-server"
        );
      } else {
        if (apirespone.status == 200) {
          var responseData = {};
          let apidata = await apirespone.json();
          console.log("Locations apidata" + JSON.stringify(apidata));
          responseData.parkData = apidata.all_locations
            .filter(info => info.location_name !== "") // Filter out items with an empty location_name
            .map(info => ({
              geometry: {
                coordinates: [parseFloat(info.latitude), parseFloat(info.longitude)],
                location_id: info.location_id,
                location_name: info.location_name,
                address: info.address,
                noo_verified: info.noo_verified,
                pri_contact: info.pri_contact,
                pri_num: info.pri_num,
                is_911: info.is_911,
              },
            }));
          const uniqueNames = [...new Set(responseData.parkData.map((location) => location.geometry.location_name))];
          setlocationNames(uniqueNames);

          setData(responseData.parkData);
          setFillData(responseData.parkData)
        }
      }
    } catch (e) {
      console.log("Error in getLiveApiDataDevicesInfo :" + e);
    }
  }

  const [currentMarkerOjects, setCurrrentMarkerOjects] = useState([]);
  var markerData = [];
  function getMarkerData(coordinates) {
    try {
      console.log("[getMarkerData] : coordinates: " + JSON.stringify(coordinates));
      var markerPointData = [];

      if (data && data) {
        coordinates.forEach(element => {
          data.forEach(park => {
            if (element.every((ele, index) => ele == park.geometry.coordinates[index])) {
              markerPointData.push(park);
            }
          });
        });
      }

      console.dir(markerPointData);
      setCurrrentMarkerOjects(markerPointData);
      return markerPointData;
    } catch (e) {
      console.error("Error in getMarkerData  :" + e);
    }
  }
  const handletext = (coordinates) => {
    console.dir("marker Data :::::::: " + coordinates);
    markerData = getMarkerData(coordinates);
    //getNeerest_911_profile(coordinates, markerData);    //Neglecting calculations at UI End 
    return (
      <>
        <div className="LocmapPopUpBig">
          <div className="p-3">{framepopupHeaders(markerData)}</div>
          <div className="LeafLetPopUpTable">
            <div className="Table">
              <MDBTable small>
                <MDBTableHead>
                  <tr>
                    {tableHeaders.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                </MDBTableHead>
                <MDBTableBody
                  id="devicestable_content_id"
                  ref={devices_rows}
                  className="mapTable"
                >
                  {markerData.map((element) => (
                    <tr key={element?.geometry?.location_id} id={"row_location_" + element?.geometry?.location_id}>
                      <td>
                        <p className='fw-bold mb-0'>{element?.geometry?.pri_contact} </p>
                      </td><td>
                        <p className='fw-bold mb-0'>
                          {element?.geometry?.noo_verified ? (
                            <MDBIcon fas icon="check" className="ms-4 ps-1 primary checked-icon" />
                          ) : (
                            <div className="no-red ms-4 fw-bold">No</div>
                          )}
                        </p></td>
                      <td id={element?.geometry?.location_id + "_coordinates"}><MDBIcon fas icon="map-marker-alt" /></td>
                    </tr>
                  ))}
                </MDBTableBody>
              </MDBTable>
            </div>
          </div>
        </div>
      </>
    )
  }
  const handleClusterClickContent = (coordinates) => {
    console.dir("handleClusterClickContent coordinates " + coordinates);
    markerData = getMarkerData(coordinates);
    let blueMarkers = markerData.filter((item) => !item.geometry.is_911)
    return (
      <>
        <div className="mapPopUpSmall">
          <div className="d-flex align-items-center">
            <img src={blueMarkers.length > 0 ? BlueLocation : Location} className="emergencyModal-logo" />
            <h4 className="fw-bold mb-0">Locations</h4>
          </div>
          <MDBTable small>
            <MDBTableHead>
              <tr>
                {tableHeadersNew.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </MDBTableHead>
            <MDBTableBody
              id="devicestable_content_id"
              ref={devices_rows}
              className="mapTable"
            >
              {markerData.map((element) => (
                <tr key={element?.geometry?.location_id} id={"row_location_" + element?.geometry?.location_id}>
                  <td>
                    <div className='d-flex align-items-center'>

                      <div className=''>
                        <p className='fw-bold mb-0'>{element?.geometry?.location_name}</p>
                        <p className='tel-numbers-small'>{element?.geometry?.address}</p>
                      </div>
                    </div>
                  </td>
                  <td>
                    <p className='fw-bold mb-0'>
                      {element?.geometry?.noo_verified ? (
                        <MDBIcon fas icon="check" className="ms-4 ps-1 primary checked-icon" />
                      ) : (
                        <div className="no-red ms-4 fw-bold">No</div>
                      )}
                    </p>
                  </td>
                  <td>
                    <p className='fw-bold mb-0'>{element?.geometry?.pri_contact}</p>
                  </td>
                  <td id={element?.geometry?.location_id + "_coordinates"}>
                    <MDBIcon fas icon="map-marker-alt" />
                  </td>
                </tr>
              ))}
            </MDBTableBody>
          </MDBTable>
        </div>
      </>
    )
  }
  const framepopupHeaders = (markerData) => {
    //Check for single device header 
    if (markerData.length > 1) {   // returns header for multidevice Location
      console.log("[Map][framepopupHeaders] Returned Multi device Location header + ", markerData);
      return (
        <>
          <div className="d-flex justify-content-start">
            <div className="px-3 modal-title w-100">{"List of Locations"}</div>
          </div>
        </>
      )
    } else if (markerData.length == 1) {
      console.log("[Map][framepopupHeaders] Returned with single device header " + JSON.stringify(markerData));
      return (<>
        <h5 className="mb-3 modal-title">{markerData[0]?.geometry?.is_911 ? '911 Only Location' : 'Office Location'}</h5>
        <div className="d-flex justify-content-start">
          <img src={markerData[0]?.geometry?.is_911 ? Location : BlueLocation} className="emergencyModal-logo" />
          <div className='ms-3'>
            <p className='fw-bold mb-0 '>{markerData[0]?.geometry?.location_name}</p>
            <p className='tel-numbers-small'>{markerData[0]?.geometry?.address}</p>
          </div>
        </div>
      </>)
    }

  };
  function markersPointingToSameLocation(array) {
    try {
      const firstObject = JSON.stringify(array[0]._latlng); // Serialize the first object
      return array.every(obj => JSON.stringify(obj._latlng) === firstObject);
    } catch (e) {
      console.log("error :: markersPointingToSameLocation " + e);
    }
    return false;
  }

  var closePopupTime;
  const clickListeners = []; // Created an array to store the event listener functions
  // const [currentGeoCoordinates, setcurrentGeoCoordinates] = useState({});
  var popupRef = useRef(null);
  const loadMap = () => {
    console.log("Request came to load Map ::::");
    const mapNode = document.getElementById("mapId");
    var markerBounds = [];
    if (!mapNode || map.current) {
      map.current.remove();
    }
    map.current = L.map(mapNode, { minZoom: 3, attributionControl: false, maxBounds: [[-90, -180], [90, 180]] })
    // As per PRD: Make the map black and white
    const tileLayer = L.tileLayer(
      `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png/${UIConstant.MAP_API_KEY}`,
      {
        maxZoom: 18,
        noWrap: true
      }
    ).addTo(map.current);
    L.control
      .attribution({
        position: 'bottomright' // Position the attribution at the bottom left
      })
      .addAttribution('©<a href="https://carto.com" target="_blank">CARTO</a> | <a href="https://www.openstreetmap.org/copyright" target="_blank"></a> <strong>Disclaimer:</strong>Some devices may be showing an approximate location.')
      .addTo(map.current);
    map.current.zoomControl.remove();
    L.control.zoom({
      position: 'bottomright'
    }).addTo(map.current);

    const clusterLayer = L.markerClusterGroup({
      maxClusterRadius: 40,
      minClusterSize: 1,
      disableClusteringAtZoom: 13,
      spiderfyOnMaxZoom: false,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: false,
      iconCreateFunction: function (cluster) {
        const childMarkers = cluster.getAllChildMarkers();
        const blueMarkers = childMarkers.filter(marker => marker.options.icon.options.className === "blue-tower-icon");
        const redMarkers = childMarkers.filter(marker => marker.options.icon.options.className === "red-tower-icon");
        console.log("markersPointingToSameLocation.......:" + markersPointingToSameLocation(childMarkers));
        if (childMarkers.length > 1 && markersPointingToSameLocation(childMarkers)) {
          return L.divIcon({
            html: `${cluster.getChildCount()}`,
            className: 'blue-tower-icon', iconUrl: TowerIconBlue, html: `<p class="map-marker-badge">${cluster.getChildCount()}</p>`,
            iconSize: [30, 30]
          });
        } else {
          return L.divIcon({
            html: `<div><span style="color: #fff;">${cluster.getChildCount()}</span></div>`,
            className: `custom-cluster-icon ${blueMarkers.length > 0 ? '' : 'red-cluster'} `,
            iconSize: [30, 30]
          });
        }
      }
    });

    tileLayer.on("load", () => {
      console.log("Map has finished loading!");
      setIsloading(false); // hiding loader currently displaying in UI
    });


    var mark = [];
    if (data && data.length > 0) {
      let customicon = "";
      const markerArray = [];

      data.forEach((obj, index) => {
        let multi_records = data.filter(item => (
          item.geometry.coordinates[0] == obj.geometry.coordinates[0] &&
          item.geometry.coordinates[1] == obj.geometry.coordinates[1]
        ));
        let office_locations = multi_records.filter((item) => !item.geometry.is_911)


        if (multi_records.length > 1) {
          if (office_locations.length > 0) {
            customicon = L.divIcon({
              className: 'blue-tower-icon', iconUrl: TowerIconBlue, html: `<p class="map-marker-badge">${multi_records.length}</p>`
            });
          } else {
            customicon = L.divIcon({
              className: 'red-tower-icon', iconUrl: TowerIconRed, html: `<p class="map-marker-badge">${multi_records.length}</p>`
            });
          }

        } else {
          if (multi_records[0].geometry.is_911) {
            customicon = L.divIcon({
              className: 'red-tower-icon', iconUrl: TowerIconRed, html: `<p class="map-marker-badge">${multi_records.length}</p>`
            });
          } else {
            customicon = L.divIcon({
              className: 'blue-tower-icon', iconUrl: TowerIconBlue, html: `<p class="map-marker-badge">${multi_records.length}</p>`
            });
          }

        }

        const marker = L.marker(obj.geometry.coordinates, { icon: customicon });
        mark.push(marker);
        marker.addTo(clusterLayer);
        markerArray.push(obj.geometry.coordinates);
      });

      map.current.addLayer(clusterLayer);
      // Get bounds of the marker cluster group
      console.log("markerArray :" + JSON.stringify(markerArray));
      markerBounds = L.latLngBounds(markerArray);
      addMouseEvents(clusterLayer);

    }


    setTimeout(() => {
      try {
        map.current.invalidateSize();

        if (Object.entries(markerBounds).length > 0) {
          map.current.fitBounds(markerBounds);
        } else {
          const defaultBounds = [
            [49.38, -66.94], // Northeast corner
            [24.52, -125.00] // Southwest corner
          ];
          map.current.fitBounds(defaultBounds);
          console.log("No markers in map ");
        }

      } catch (e) {
        console.error("Error in fitBounds :" + e);
      }
    }, 300);


  };

  const addMouseEvents = (clusterLayer) => {
    try {
      clusterLayer.on("mouseover", (e) => {   //will use on Marker mouseover 
        console.log("Marker MouseOver called ::::::::::::");
        if (popupRef?.current) {
          popupRef.current.remove();
          popupRef.current = null;
          setTimeout(() => {
            handleClickOnMarker([[e.latlng.lat, e.latlng.lng]], e);
          }, 300)
          clearTimeout(closePopupTime)
        }

        else {
          setTimeout(() => {
            handleClickOnMarker([[e.latlng.lat, e.latlng.lng]], e);
          }, 300)
        }
      });
      clusterLayer.on("mouseout", (e) => {   //will use on Marker for mouse out 
        console.log("Marker MouseLeave Called:::::::::::::");
        if (popupRef?.current?._container) {
          var popupElement = popupRef.current._container;
          console.log("popupRef.current: " + popupRef.current);
          console.dir(popupRef.current);
          console.log("Event....");
          console.dir(e);
          var clusterElement = e.originalEvent.relatedTarget;
          // Check if the mouse is still over the cluster marker or if it has moved to the popup content
          if (!clusterElement || !popupElement.contains(clusterElement)) {
            // Close the popup only if the mouse has left the cluster marker
            closePopupTime = setTimeout(() => {
              if (popupRef.current) {
                popupRef.current.remove();
                popupRef.current = null; // Reset the popup reference
              }
            }, 1000);
          }
        }

      });

      //Will use this event for click on Cluster , it will Zoom map to bounds and set Zoom level 
      clusterLayer.on("clusterclick", function (a) {
        map.current.fitBounds(a.layer.getBounds(), { maxZoom: map.current.getMaxZoom() });
      });

      clusterLayer.on("clustermouseover", function (a) {
        console.log("clustermouseover called:::::::::::::");
        console.log(a.layer.getAllChildMarkers());
        console.dir(a);
        let childCoordinatesSet = new Set();
        a.layer.getAllChildMarkers().forEach(e => {
          let latLng = e.getLatLng();
          let coordStr = `${latLng.lat},${latLng.lng}`;
          childCoordinatesSet.add(coordStr);
        });

        // Convert the Set back to an array of coordinate arrays
        let childCoordinates = Array.from(childCoordinatesSet).map(coordStr => {
          let [lat, lng] = coordStr.split(',').map(Number);
          return [lat, lng];
        });
        if (popupRef?.current) {
          popupRef.current.remove();
          popupRef.current = null;
          setTimeout(() => {
            handleClickOnMarker(childCoordinates, a, true);
          }, 300)
          clearTimeout(closePopupTime)
        }
        else {
          setTimeout(() => {
            handleClickOnMarker(childCoordinates, a, true);
          }, 300)
        }
      });

      clusterLayer.on("clustermouseout", function (a) {
        if (popupRef?.current?._container) {
          var popupElement = popupRef.current._container;
          var clusterElement = a.originalEvent.relatedTarget;
          // Check if the mouse is still over the cluster marker or if it has moved to the popup content
          if (!clusterElement || !popupElement.contains(clusterElement)) {
            // Close the popup only if the mouse has left the cluster marker
            closePopupTime = setTimeout(() => {
              if (popupRef.current) {
                popupRef.current.remove();
                popupRef.current = null; // Reset the popup reference
              }
            }, 1000);
          }
        }
      });
    } catch (e) {
      console.error("Error in while adding MouseEvents to Map clustors and markers : " + e);
    }
  }

  const handleClickOnMarker = (coordinatesAray, e, isClusterClick) => {   // [[12.2342,-89.3425],[13.1234,78.5432]]
    console.log("[handleClickOnMarker] Marker Clicked geo - coordinates : " + JSON.stringify(coordinatesAray) + " latLang " + e.latlng);
    const clickedCoordinates = e.latlng; //Extract Clicked coordinates
    let content1;
    // setcurrentGeoCoordinates(e.latlng);
    if (isClusterClick) {
      content1 = handleClusterClickContent(coordinatesAray);
    } else {
      content1 = handletext(coordinatesAray);
    }
    const content = ReactDOMServer.renderToStaticMarkup(content1);
    popupRef.current = L.popup({
      maxWidth: 650, // Set your desired maximum width
    }).setContent(content);

    popupRef.current.setLatLng(clickedCoordinates).openOn(map.current);
    if (popupRef.current) {
      console.log("Popup opened");
      console.dir("markerData ::: " + markerData);
      // if (document.getElementById("popup-input")) {
      //   const inputElement = document.getElementById("popup-input");
      //   // Attach a custom event listener for input change on searchbox in case of popup display
      //   // inputElement.addEventListener("input", (event) => {
      //   //   setSearchValues(event);
      //   // });
      // }

      if (markerData.length > 0) {
        markerData.forEach((element) => {
          const listenerFunction = async (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log("Click operation is performed on:", JSON.stringify(element));
            await navigateToLocationSettings(element);
          };
          const coordinatesListener = (e) => {
            e.preventDefault();
            e.stopPropagation();
            console.log("Click operation Location ::::");
            if (map.current) {
              map.current.setView(element.geometry.coordinates, map.current.getMaxZoom());
            }
          };

          const locationElement = document.getElementById("row_location_" + element?.geometry?.location_id);
          const coordinatesElement = document.getElementById(element?.geometry?.location_id + "_coordinates");

          if (locationElement) {
            locationElement.addEventListener("click", listenerFunction);
          } else {
            console.error(`Location element not found for ID: ${element?.geometry?.location_id}`);
          }

          if (coordinatesElement) {
            coordinatesElement.addEventListener("click", coordinatesListener);
          } else {
            console.error(`Coordinates element not found for ID: ${element?.geometry?.location_id + "_coordinates"}`);
          }
          clickListeners.push({ element, listenerFunction, coordinatesListener });
        });
      }
      popupRef.current._container.addEventListener("mouseenter", () => {
        clearTimeout(closePopupTime);
        console.log("Popup hovered.");
      });
      map.current.on("popupclose", () => {
        console.log("Popup closed");

        clickListeners.forEach(({ element, listenerFunction, coordinatesListener }) => {
          const locationElement = document.getElementById("row_location_" + element?.geometry?.location_id);
          const coordinatesElement = document.getElementById(element?.geometry?.location_id + "_coordinates");

          if (locationElement) {
            locationElement.removeEventListener("click", listenerFunction);
          }

          if (coordinatesElement) {
            coordinatesElement.removeEventListener("click", coordinatesListener);
          }
        });
        clickListeners.length = 0;
      });

      if (popupRef.current && popupRef.current._container) {
        const popupContainer = popupRef.current._container;
        const mouseLeaveHandler = () => {
          if (popupRef.current) {
            popupRef.current.remove(); // Close the popup
            popupRef.current = null; // Reset the popup reference
          }
          popupContainer.removeEventListener('mouseleave', mouseLeaveHandler);
        };
        popupContainer.addEventListener('mouseleave', mouseLeaveHandler);
      }
    }
  };

  async function navigateToLocationSettings(evntData) {
    console.log("911 evntData ::::::::: " + JSON.stringify(evntData));
    if (evntData?.geometry?.is_911) {
      console.log("911 location911settings condition ::::::::: " + JSON.stringify(evntData));
      navigate("/location911settings", {
        state: evntData.geometry,
      });
    } else {
      console.log("911 locDetails condition ::::::::: " + JSON.stringify(evntData));
      navigate("/locDetails", {
        state: evntData.geometry,
      });
    }
  }

  useEffect(() => {
    getLocationsInfo();
  }, []);

  useEffect(() => {
    if (data != null) {
      // setTimeout(() => {
      console.log("Map is loading :::::::::::");
      loadMap();
      // }, 1000);
    }
    setTimeout(()=>{
        searchRef.current.focus();
      },500)
  }, [data]);

  const handleAddLocation = async (newLocation) => {
    console.log("Adding new location:", newLocation);
    await getLocationsInfo();  // Refresh locations after adding
    setShowAddLocationPopup(false); // Close the popup
  };
  // Utility function to check if two arrays are equal (order-independent)
  const isArraysEqual = (arr1, arr2) => {
    return (
      Array.isArray(arr1) &&
      Array.isArray(arr2) &&
      arr1.length === arr2.length &&
      arr1.every((val) => arr2.includes(val))
    );
  };
  const [basicActive, setBasicActive] = useState('tab1');
  const [nineActive, setNineActive] = useState(false);
  const [officeActive, setOfficeActive] = useState(false);


  const handleBasicClick = (value, loc) => {
    if (value === basicActive && loc === 1) {
      return;
    }
    let uniqueNames
    setFilterSelectedLocations([]);
    setSelectedLocationchips("");
    setSelectedOption("")
    if (value === "tab1") {
      uniqueNames = [...new Set(fillData.map((location) => location.geometry.location_name))];
      setData(fillData);
      setlocationNames(uniqueNames);
      setNineActive(false)
      setOfficeActive(false)
    }
    if (value === "tab2") {
      uniqueNames = [...new Set(fillData.filter((loc) => !loc.geometry.is_911).map((location) => location.geometry.location_name))];
      const ofice = fillData.filter((loc) => !loc.geometry.is_911);
      setData(ofice);
      setlocationNames(uniqueNames);
      setNineActive(false)
      setOfficeActive(!officeActive)
    }
    if (value === "tab3") {
      uniqueNames = [...new Set(fillData.filter((loc) => loc.geometry.is_911).map((location) => location.geometry.location_name))];
      const nineooo = fillData.filter((loc) => loc.geometry.is_911);
      setData(nineooo);
      setlocationNames(uniqueNames);
      setNineActive(true)
      setOfficeActive(false)
      
    }
    setBasicActive(value);
  };

  return (
    <>

      <MDBTabs className='mb-3'>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab1', 1)} active={basicActive === 'tab1'}>
            All Locations
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab2', 1)} active={basicActive === 'tab2'}>
            Office
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => handleBasicClick('tab3', 1)} active={basicActive === 'tab3'}>
            911 Only
          </MDBTabsLink>

        </MDBTabsItem>
      </MDBTabs>



      <div className="mapSearch d-flex justify-content-between align-items-center">

        {/* Search Box Section */}
        <div className="d-flex align-items-center">
          <div className="searchFilter">
            <Select
              options={searchData}
              // onInputChange={(inputValue) => handleMapLocationSearch(inputValue)}
              value={selectedOption}
              onChange={handleChange}
              isClearable
              isSearchable
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              placeholder="Search Location..."
              styles={{ border: "none" }}
              onMenuClose={closeSearch}
              // menuPortalTarget={document.body}
              classNamePrefix="react-select"
              ref={searchRef}
            />
          </div>
          {selectedLocation && (
            <div className="d-flex align-items-center popconfirmFilter me-3">
              <MDBChip
                closeIcon
                className="m-0"
                onClose={() => {
                  // When the clear icon is clicked, reset the map to show all locations
                  setSelectedLocation(null); // Clear the selected location
                  setFilterSelectedLocations([]); // Clear selected locations
                  setTempSelectedLocations([]); // Clear temporary selected locations
                  handleBasicClick(basicActive, 2) // Reset the map data to show all locations
                  setAllLocation(false)
                }}
              >
                <div className="filterElliipse">
                  {selectedLocation.label} {/* Display the selected location */}
                </div>
              </MDBChip>
            </div>
          )}

          {/* Add Filter & Selected Filters Section */}
          <div className="ms-3 d-flex align-items-center flex-row-reverse">
            {/* Add Filter Button with Clear Button on its right */}
            <div className="d-flex align-items-center gap-2">
              <MDBPopconfirm
                onClose={() => setShowLocation(false)}
                placement="bottom-start"
                btnChildren={(
                  <>
                    <MDBIcon fas icon="filter" className="me-2" /> {t("addFilter")}
                  </>
                )}
              >
                <MDBPopconfirmMessage>
                  <div>
                    <p className="mb-3 fw-600 filterhead">
                      {showLocation ? "Location" : "Filter by"}
                    </p>

                    {!showLocation && (
                      <div className="d-flex flex-column mt-2 cursor-pointer">
                        <div
                          className={`d-flex flex-column ${filterSelectedLocations.length > 0 ? 'Filter_disabled' : ''}`}
                          onClick={filterSelectedLocations.length > 0 ? null : toggleLocation}
                        >
                          Location
                        </div>
                      </div>
                    )}

                    {showLocation && (
                      <>
                        <input
                          type="text"
                          placeholder="Search Location..."
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          className="mb-2 form-control w-100"
                          ref={inputSearchRef}
                        />
                        <MDBCheckbox
                          id="allLocationCheckbox"
                          checked={allLocation}
                          onChange={(e) => handleAllLocation(e)}
                          label="All Locations"
                        />
                        <div className="filtersScroll">
                          {locationNames?.filter(location => location.toLowerCase() !== "all locations" && location.toLowerCase().includes(searchValue.toLowerCase()))?.map(location => (
                            <MDBCheckbox
                              title={location}
                              key={location}
                              name="flexCheckLocation"
                              value={location}
                              id={`flexCheckLocation_${location}`}
                              label={location}
                              checked={tempSelectedLocations.includes(location)}
                              onChange={() => handleFilterLocations(location)}
                              disabled={location.toLowerCase() === "all locations"}
                            />
                          ))}
                        </div>

                        <MDBModalFooter className="d-flex align-items-center justify-content-between pt-3">
                          <MDBBtn size="sm" outline color="secondary" onClick={(e) => toggleBackClick(e, 1)}>Back</MDBBtn>

                          {tempSelectedLocations.length > 0 && (
                            <div>
                              <MDBBtn size="sm" color="secondary" onClick={cancelFilter}>Cancel</MDBBtn>
                              <MDBBtn size="sm" className="ms-2" onClick={filterLocations}>
                                Apply
                              </MDBBtn>
                            </div>
                          )}
                        </MDBModalFooter>
                      </>
                    )}
                  </div>
                </MDBPopconfirmMessage>
              </MDBPopconfirm>

              {/* Clear Button on the right side of Add Filter */}
              {filterSelectedLocations.length > 0 && (
                <MDBBtn size="sm" onClick={clearFilterData}>
                  Clear
                </MDBBtn>
              )}
            </div>

            {/* Selected Filter popup for Chips */}
            {filterSelectedLocations.length > 0 && (
              <div className="d-flex align-items-center popconfirmFilter me-3">
                <MDBPopconfirm
                  className="p-0 w-auto"
                  color="light"
                  placement="bottom-start"
                  rippleRadius={10}
                  btnChildren={(
                    <>
                      <MDBChip
                        title={filterSelectedLocations.join(", ")}
                        closeIcon
                        className="m-0"
                        onClose={() => {
                          setFilterSelectedLocations([]);     // Remove chip
                          setTempSelectedLocations([]);       // Optional reset
                        }}
                        onDelete={() => {
                          clearFilterData(); // Clear all selected locations and reset the map
                          handleBasicClick(basicActive, 2) // Reset the map data to show all locations
                        }}
                      >
                        <div className="filterElliipse">
                          Location: {filterSelectedLocations.join(", ")}
                        </div>
                      </MDBChip>
                    </>
                  )}
                >
                  <>
                    <MDBInput
                      type="text"
                      placeholder="Search Location..."
                      value={searchValue}
                      onChange={(e) => setSearchValue(e.target.value)}
                      className="mb-2"
                    />
                    <MDBCheckbox
                      id="allLocationCheckbox"
                      checked={allLocation}
                      onChange={(e) => handleAllLocation(e)}
                      label="All Locations"
                    />
                    <div className="filtersScroll">
                      {locationNames?.filter(location => location.toLowerCase() !== "all locations" && location.toLowerCase().includes(searchValue.toLowerCase()))?.map(location => (
                        <MDBCheckbox
                          key={location}
                          name="flexCheckLocation"
                          value={location}
                          id={`flexCheckLocation_${location}`}
                          label={location}
                          checked={tempSelectedLocations.includes(location)}
                          onChange={() => handleFilterLocations2(location)}
                          disabled={location.toLowerCase() === "all locations"}
                        />
                      ))}
                    </div>

                    {!isArraysEqual(tempSelectedLocations, filterSelectedLocations) && tempSelectedLocations.length > 0 && (
                      <MDBModalFooter className="d-flex align-items-center justify-content-end pt-3">
                        <div>
                          <MDBBtn size="sm" color="secondary" onClick={cancelFill} >
                            Cancel
                          </MDBBtn>
                          <MDBBtn size="sm" className="ms-2" onClick={filterLocations}>
                            Apply
                          </MDBBtn>
                        </div>
                      </MDBModalFooter>
                    )}
                  </>
                </MDBPopconfirm>
              </div>
            )}
          </div>
        </div>
        {/* Add Location Section - Now Aligned to the Right */}
        {
          !nineActive && !officeActive ?
         <>
         <div className="d-flex">
          <div className="addLocationSection me-2">
          <MDBBtn onClick={toggleAddLocationPopup}>
            <MDBIcon fas icon="plus" size="sm" /> Add Location
          </MDBBtn>
        </div> 
        <div className="addLocationSection ">
        <MDBBtn onClick={()=>{
          props.toggleShow25()
          }}>
          <MDBIcon fas icon="plus" size="sm" /> Add 911Location
        </MDBBtn>
      </div>
      </div>
         </>:
         (
          officeActive ?
          <div className="addLocationSection me-2">
          <MDBBtn onClick={()=>{
             toggleAddLocationPopup()
             props.setBasicActive("tab2")
          }}>
            <MDBIcon fas icon="plus" size="sm" /> Add Location
          </MDBBtn>
        </div> :
          <div className="addLocationSection ">
          <MDBBtn onClick={()=>{
          props.toggleShow25()
          props.setBasicActive("tab3")
          }}>
            <MDBIcon fas icon="plus" size="sm" /> Add 911Location
          </MDBBtn>
         </div> 
         )
       
        }
      </div>

      <div className="mapSearch d-flex">
        <div>
        </div>
        <div className="ms-3">
        </div>
      </div>
      <div
        style={{ width: "100%", height: "calc(100vh - 280px)" }}
        id="mapId"
      >
      </div>
      {isloading && (
        <div>
          <div className="loadingclass-popup"></div>
          <div className="popup-bg-loader loader_align">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </div>
      )}
      {showAddLocationPopup && (
        <PopupLoaderNew
          title={"Add Location"}
          content={
            <AddLocations
              onClose={() => setShowAddLocationPopup(false)}
              ref={addLocationRef}
              setIsloading={setIsloadingMap}
              onAddLocation={handleAddLocation}
            />
          }
          className="modal-lg"
          onShow={setShowAddLocationPopup}
          onClose={toggleAddLocationPopup}
          onClosePopup={closePopup}
          onSave={handleClick}
          isloading={isloadingMap}
          flag={1}
        />
      )}
      
    </>
  );
}

export default LocationMap;
